import { RequirePermission } from "@backstage/plugin-permission-react";
import { administerPermission } from "@internal/plugin-admin-common";
import {
    RiBarChartBoxLine,
    RiEyeLine,
    RiLockLine,
    RiTeamLine,
    RiTerminalBoxLine,
} from "@remixicon/react";

import { NAV_ICON_SIZE, SUBMENU_ICON_SIZE } from "../constants";
import { type SidebarEntry } from "../types";
import { SidebarSubmenu } from "./SidebarSubmenu";

const adminEntries: SidebarEntry[] = [
    {
        title: "DevTools",
        href: "/devtools",
        icon: <RiTerminalBoxLine size={SUBMENU_ICON_SIZE} aria-hidden />,
    },
    {
        title: "RBAC",
        href: "/rbac",
        icon: <RiTeamLine size={SUBMENU_ICON_SIZE} aria-hidden />,
    },
    {
        title: "Insights",
        href: "/insights",
        icon: <RiBarChartBoxLine size={SUBMENU_ICON_SIZE} aria-hidden />,
    },
    {
        title: "Visualizer",
        href: "/visualizer",
        icon: <RiEyeLine size={SUBMENU_ICON_SIZE} aria-hidden />,
    },
];

/**
 * Administrative tools, shown only to holders of the administer permission.
 *
 * Rendering nothing (rather than a disabled entry) for unauthorised users is
 * intentional and unchanged from the previous implementation: the presence of
 * these tools is not something every user needs to know about.
 */
export const AdminSidebar = () => (
    <RequirePermission permission={administerPermission} errorPage={<></>}>
        <SidebarSubmenu
            icon={<RiLockLine size={NAV_ICON_SIZE} aria-hidden />}
            text="Admin"
            entries={adminEntries}
        />
    </RequirePermission>
);
